import { render, staticRenderFns } from "./BaseEntry.vue?vue&type=template&id=4ccdcaaa&scoped=true"
import script from "./BaseEntry.vue?vue&type=script&lang=js"
export * from "./BaseEntry.vue?vue&type=script&lang=js"
import style0 from "./BaseEntry.vue?vue&type=style&index=0&id=4ccdcaaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdcaaa",
  null
  
)

export default component.exports